import "./FinanceAboutUs.scss"

const FinanceAboutUs = () => {

    return (
        <>
            <div className="financeAboutUsOuterDiv">
                <div className="financeAboutUsInnerDiv">
                    <div className="financeAboutUsImageDiv">
                        <img src="../assets/img/finance/financeAboutUsImage.png" alt="About Us" id="financeAboutUsImage" />
                        <img src="../assets/img/finance/bannerRevenueCard.png" className="overlay" alt="Revenue Card" id="financeRevenue" />
                        <img src="../assets/img/finance/financeAboutUsExp.png" className="overlay" alt="Experience" id="financeExp" />
                    </div>

                    <div className="financeAboutUsTextDiv">
                        <button id="financeAboutUsButton">
                            ABOUT US
                        </button>

                        <p id="financeABoutUsHeading">
                            Unlock the Right Strategies, Support, And Expertise
                        </p>

                        <p id="financeAboutUsPara">
                            We approached Consultez for a complex project involving website design, which required attention to various aspects such as layout, graphics, and content experience.
                        </p>

                        <div className="financeAboutUsLogoOuterDiv">
                            <div className="financeAboutUsLogoInnerDiv">
                                <img src="../assets/img/finance/financeAboutUsLogo1.png" alt="Logo1" className="financeAboutUsLogo" />
                                <p id="financeABoutUsTileText"> Building Credibility Proven Success </p>
                            </div>

                            <div className="financeAboutUsLogoInnerDiv">
                                <img src="../assets/img/finance/financeAboutUsLogo2.png" alt="Logo2" className="financeAboutUsLogo" />
                                <p id="financeABoutUsTileText"> Ensuring Efficiency, Superior Results. </p>
                            </div>
                        </div>

                        <div className="financeAboutUsPointsDiv">
                            <div className="financeAboutUsPoint">
                                <span class="material-symbols-outlined">
                                    check
                                </span>
                                <p> Business Consultancy </p>
                            </div>

                            <div className="financeAboutUsPoint">
                                <span class="material-symbols-outlined">
                                    check
                                </span>
                                <p> Skilled Creative Team </p>
                            </div>
                        </div>
                        <div className="financeAboutUsLastDiv">
                            <button id="financeMoreAboutButton">
                                More About
                                <span class="material-symbols-outlined">
                                    arrow_forward_ios
                                </span>
                            </button>

                            <div className="financeAboutUsUsers">
                                <div className="financeAboutUsUsersFlex">
                                    <img src="../assets/img/finance/financeAboutUsUser1.png" alt="User1" class="financeUserImage" id="financeAboutUsUser1" />
                                    <img src="../assets/img/finance/financeAboutUsUser2.png" alt="User2" class="financeUserImage" id="financeAboutUsUser2" />
                                    <img src="../assets/img/finance/financeAboutUsUser3.png" alt="User3" class="financeUserImage" id="financeAboutUsUser3" />
                                    <img src="../assets/img/finance/financeAboutUsUser4.png" alt="User4" class="financeUserImage" id="financeAboutUsUser4" />
                                </div>

                                <div className="financeAboutUsUsersTextDiv">
                                    <p id="financeAboutUsUsersText"> 10M+ Impact Across the World. </p>
                                    <img src="../assets/img/finance/financeAboutUsTextUnderline.png" alt="financeAboutUsTextUnderline" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default FinanceAboutUs;